import ContactsService from "../services/contactsService";

/**
 * Loads the service/persistant/sticky contacts from the server.
 *
 * @param {String}  securityToken   The security token for the user.
 */
export function loadServices(securityToken) {
  return (dispatch, getstate) => {
    if (!securityToken) {
      securityToken = getstate().user.securityToken;
    }

    dispatch({
      type: "SERVICES_LOADING",
      payload: {},
    });

    ContactsService.getPersistantContacts(
      getstate().config.server,
      securityToken,
      dispatch,
      getstate().network.serverError
    )
      .done(data => {
        var services = data.contactList.map((item, index) => {
          return {
            id: item.id,
            name: item.fname,
            imageUrl: item.imageUrl,
            sipaddress: item.sipaddress,
          };
        });
        dispatch({
          type: "SERVICES_LOADED",
          payload: { services: services },
        });
      })
      .fail(() => {
        console.warn("Could not get persistant contacts from server");
      });
  };
}






// WEBPACK FOOTER //
// ./src/actions/serviceActions.js